import {
  getUserAttributesControllerGetUserAttributeQueryKey,
  UserAttributeName,
} from '@docnboard/rest';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { Country } from 'react-phone-number-input';

import { useUpdateUserAttributes } from '../api';

export const useUserAttributes = () => {
  const _queryClient = useQueryClient();

  const queryUpdateUserPhoneNumber = useUpdateUserAttributes({
    mutation: {
      onSuccess: async () => {
        await _queryClient.invalidateQueries({
          queryKey: getUserAttributesControllerGetUserAttributeQueryKey({
            attribute: UserAttributeName.phone_number,
          }),
        });
      },
    },
  });

  const handlePhoneSave = useCallback(
    (phoneNumber: string, phoneCountry: Country) => {
      queryUpdateUserPhoneNumber.mutate({
        data: {
          phone_number: phoneNumber,
          phone_country: phoneCountry,
        },
      });
    },
    [queryUpdateUserPhoneNumber]
  );

  return { handlePhoneSave };
};
